import "./usercreditcard.scss";
import AddCircleIcon from '@mui/icons-material/AddCircle';

interface IUserCreditCard {
    name:string
    credit:string
}

const UserCreditCard = ({name,credit}:IUserCreditCard) => {
    return(
        <div className="User-Credit-Card">
            <div className="User-Credit-Card-Right">
                <img src={require("../../assets/images/PureLogoLight.svg").default} alt="" className="img-fluid"/>
                <div>
                    <span>نام و نام خانوادگی</span>
                    <p>{name}</p>
                    <span>موجودی</span>
                    <h6>{credit} تومان</h6>
                </div>
                <div className="d-flex align-items-center cursor-pointer">
                    <AddCircleIcon fontSize={"small"}/>
                    <span className="pe-2">افزایش موجودی</span>
                </div>
            </div>
            <div className="User-Credit-Card-Left">
                <img src={require("../../assets/images/photos/UserCreditCard.svg").default} alt="" className="img-fluid"/>
            </div>
        </div>
    );
}

export default UserCreditCard